import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import Modal from '@material-ui/core/Modal';
import CircularProgress from '@material-ui/core/CircularProgress';
import Collapse from '@material-ui/core/Collapse';

import { intlShape, injectIntl, defineMessages } from 'react-intl';

import isLoggedIn from '../../helpers/checkAuth';
import RestrictedAccessModal from '../RestrictedAccessModal/RestrictedAccessModal';
import Link from '../Link';
import SkholeIcon22 from '../statelessComponents/Icons/SkholeIcon22';
import SkholeIconOpenBook from '../statelessComponents/Icons/SkholeIconOpenBook';

import s from './LessonsListItem.scss';
import CoursePodcastItem from '../../routes/courseDetails/CoursePodcastItem/CoursePodcastItem';
import * as lessonDetailsActions from '../../actions/lessonDetails';
import * as podcastLessonActions from '../../actions/podcastLesson';
import {
  isUserFromWhitelabeledOrganization,
  userSkillEvaluationEnabled,
} from '../../helpers';

const messages = defineMessages({
  finishLessonTitle: {
    id: 'LessonListItem.finishTitle',
    defaultMessage: 'Finished lesson',
    description: 'Finished lesson title text',
  },
  notStartedLessonTitle: {
    id: 'LessonListItem.notStartedTitle',
    defaultMessage: 'Not started lesson',
    description: 'Not started lesson title text',
  },
});

@injectIntl
@withStyles(s)
@connect(
  state => ({
    auth: state.auth,
    lang: state.intl.locale,
    offline: state.online.offline,
    courseWasReset: state.courseDetails.courseWasReset,
    isLessonLoading: state.lessonDetails.loading,
    lesson: state.lessonDetails.lesson,
    openedPodcastLesson: state.podcastLesson.openedPodcastLesson,
    isPodcastLessonLoading: state.podcastLesson.isPodcastLessonLoading,
    shouldScrollIntoView: state.podcastLesson.shouldScrollIntoView,
  }),
  dispatch =>
    bindActionCreators(
      {
        getLessonBySlug: lessonDetailsActions.getLessonBySlug,
        resetLesson: lessonDetailsActions.reset,
        setOpenedPodcastLesson: podcastLessonActions.setOpenedPodcastLesson,
        setIsLoadingPodcastLesson: podcastLessonActions.setIsLoading,
        setNextPodcastLesson: podcastLessonActions.setNextLesson,
      },
      dispatch,
    ),
)
export default class LessonsListItem extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired, // eslint-disable-line
    offline: PropTypes.bool,
    course: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      isAvailable: PropTypes.bool.isRequired,
      type: PropTypes.string,
      totalLessons: PropTypes.number,
      completedLessons: PropTypes.number,
      completedQuizzes: PropTypes.number,
      progress: PropTypes.number,
    }).isRequired,
    item: PropTypes.shape({
      _id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      time: PropTypes.number,
      isGloballyFree: PropTypes.bool,
      slug: PropTypes.string,
      youtubeVideoUrl: PropTypes.string,
    }).isRequired,
    active: PropTypes.bool,
    intl: intlShape.isRequired,
    isCompleted: PropTypes.bool,
    getLessonBySlug: PropTypes.func.isRequired,
    courseWasReset: PropTypes.bool.isRequired,
    setOpenedPodcastLesson: PropTypes.func.isRequired,
    setIsLoadingPodcastLesson: PropTypes.func.isRequired,
    setNextPodcastLesson: PropTypes.func.isRequired,
    showPodcastContent: PropTypes.bool.isRequired,
    resetLesson: PropTypes.func.isRequired,
    openedPodcastLesson: PropTypes.string,
    lesson: PropTypes.object, // eslint-disable-line
    isPodcastLessonLoading: PropTypes.bool.isRequired,
    goToNextPodcastLesson: PropTypes.func,
    isLessonLoading: PropTypes.bool.isRequired,
    shouldScrollIntoView: PropTypes.bool.isRequired,
    cancelGoToNextSectionItem: PropTypes.func,
    disabled: PropTypes.bool,
  };

  static defaultProps = {
    active: false,
    isCompleted: undefined,
    openedPodcastLesson: '',
    goToNextPodcastLesson: _.noop,
    cancelGoToNextSectionItem: _.noop,
    offline: false,
    disabled: false,
  };

  state = {
    isRestrictedAccessModalOpened: false,
  };

  onClickListItem = async event => {
    const {
      course: { type, _id: courseId },
      item,
      getLessonBySlug,
      setOpenedPodcastLesson,
      resetLesson,
      openedPodcastLesson,
      setIsLoadingPodcastLesson,
      setNextPodcastLesson,
    } = this.props;
    const isUserHasAccess = this.checkAuth(event);
    if (!isUserHasAccess) {
      return;
    }

    if (type === 'podcast') {
      const itemToOpen = item._id;
      setNextPodcastLesson({});
      if (itemToOpen === openedPodcastLesson) {
        setOpenedPodcastLesson(null);
        resetLesson();
      } else {
        setIsLoadingPodcastLesson(true);
        resetLesson();
        setOpenedPodcastLesson(itemToOpen, true);
        await getLessonBySlug(item.slug, { courseId });
        setIsLoadingPodcastLesson(false);
      }
    }
  };

  goToNextLesson = () => {
    const { lesson, goToNextPodcastLesson } = this.props;
    goToNextPodcastLesson(lesson);
  };

  checkAuth = event => {
    if (this.hasAccess()) {
      return true;
    }

    event.preventDefault();
    event.stopPropagation();

    this.setState({
      isRestrictedAccessModalOpened: true,
    });
    return false;
  };

  closeRestrictedAccessModal = () => {
    this.setState({
      isRestrictedAccessModalOpened: false,
    });
  };

  hasAccess = () => {
    const { auth, course, item } = this.props;

    return item.isGloballyFree || (isLoggedIn(auth) && course.isAvailable);
  };

  scrollToLessonListItemStart = () => {
    if (this.props.shouldScrollIntoView) {
      this.lessonRef.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  render() {
    const {
      item,
      auth,
      offline,
      course,
      active,
      intl: { formatMessage },
      isCompleted,
      courseWasReset,
      showPodcastContent,
      isPodcastLessonLoading,
      isLessonLoading,
      cancelGoToNextSectionItem,
      disabled,
    } = this.props;

    const { isRestrictedAccessModalOpened } = this.state;

    const isPodcast = course.type === 'podcast';

    const showListItem =
      !this.hasAccess() ||
      !isPodcast ||
      (isPodcast && course.totalLessons !== 1);

    const completedSectionItemsNumber =
      course.completedLessons + course.completedQuizzes;

    const isWhitelabeled = isUserFromWhitelabeledOrganization(auth);
    const isUserSkillEvaluationEnabled = userSkillEvaluationEnabled(auth);

    const showEvaluationModal =
      (!isWhitelabeled || isUserSkillEvaluationEnabled) &&
      !_.get(course, 'isUserSkillEvaluated') &&
      !course.progress &&
      !completedSectionItemsNumber &&
      !offline &&
      !isPodcast &&
      isLoggedIn(auth);

    const itemTime = timeForItem => {
      if (timeForItem.time > 3600) {
        const duration = moment.duration(timeForItem.time, 'seconds');
        return `${duration
          .hours()
          .toString()
          .padStart(2, '0')}:${duration
          .minutes()
          .toString()
          .padStart(2, '0')}:${duration
          .seconds()
          .toString()
          .padStart(2, '0')}`;
      }
      return moment(1000 * timeForItem.time).format('mm:ss');
    };

    const isTextLesson =
      !_.get(item, 'audios.length') &&
      !_.get(item, 'videos.length') &&
      !item.youtubeVideoUrl;

    return (
      <div
        ref={ref => {
          this.lessonRef = ref;
        }}
      >
        {showListItem && (
          <ListItem
            data-test-id="gnlQewAF7FIYatGN7RhxS"
            className={classNames(s.lessonListItem, { [s.active]: active })}
            component={this.hasAccess() && !isPodcast ? Link : 'div'}
            to={`/courses/${course.slug}/lessons/${item.slug}${
              showEvaluationModal ? '?showEvaluationModal' : ''
            }`}
            onClick={this.onClickListItem}
            button
            disabled={isPodcastLessonLoading || disabled}
          >
            {!isPodcast && (
              <ListItemIcon classes={{ root: s.lessonListItemIconRoot }}>
                {isTextLesson ? (
                  <SkholeIconOpenBook
                    className={s.playLessonIcon}
                    color={active ? '#fff' : 'primary'}
                  />
                ) : (
                  <SkholeIcon22
                    className={s.playLessonIcon}
                    color={active ? '#fff' : 'primary'}
                  />
                )}
              </ListItemIcon>
            )}
            {isLoggedIn(auth) && (
              <ListItemText
                primary={item.name}
                secondary={item.time ? itemTime(item) : ''}
                classes={{
                  root: s.lessonTitleTextWrapper,
                  primary: s.lessonTitleTextPrimary,
                  secondary: s.lessonTitleTextSecondary,
                }}
              />
            )}
            {!isLoggedIn(auth) && (
              <ListItemText
                primary={item.name}
                secondary={item.time ? itemTime(item) : ''}
                classes={{
                  root: s.lessonTitleTextWrapper,
                  primary: s.lessonTitleTextPrimary,
                  secondary: s.lessonTitleTextUnAuthSecondary,
                }}
              />
            )}
            <ListItemSecondaryAction className={s.secondaryAction}>
              {isCompleted && isLoggedIn(auth) && (
                <Tooltip
                  id="tooltip-finished"
                  title={formatMessage(messages.finishLessonTitle)}
                >
                  <div className={s.completedIcon} />
                </Tooltip>
              )}
              {isCompleted === false && isLoggedIn(auth) && (
                <Tooltip
                  id="tooltip-not-started"
                  title={formatMessage(messages.notStartedLessonTitle)}
                >
                  <div className={s.notCompletedIcon} />
                </Tooltip>
              )}
            </ListItemSecondaryAction>
          </ListItem>
        )}
        {(isPodcastLessonLoading || isLessonLoading) && showPodcastContent && (
          <CircularProgress size={40} className={s.lessonLoadingSpinner} />
        )}
        {isPodcast && (
          <Collapse
            mountOnEnter
            unmountOnExit
            onEntered={this.scrollToLessonListItemStart}
            in={
              showPodcastContent &&
              this.hasAccess() &&
              !isPodcastLessonLoading &&
              !isLessonLoading
            }
          >
            <CoursePodcastItem
              key={`${_.get(item, '_id')}_podcastItem_${courseWasReset}`}
              isCompleted={isCompleted}
              lessonItem={item}
              goToNextLesson={this.goToNextLesson}
              cancelGoToNextLesson={cancelGoToNextSectionItem}
            />
          </Collapse>
        )}
        <Modal
          open={isRestrictedAccessModalOpened}
          onClose={this.closeRestrictedAccessModal}
        >
          <RestrictedAccessModal onClose={this.closeRestrictedAccessModal} />
        </Modal>
      </div>
    );
  }
}
